import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
  className?: string
  hover?: boolean
  onClick?: () => void
}

/** Superficie base (borde + esquinas + sombra). El padding lo pone quien la usa. */
export function Card({ children, className = '', hover = false, onClick }: Props) {
  return (
    <div
      onClick={onClick}
      className={`rounded-2xl border border-gray-200/80 bg-white shadow-card ${
        hover ? 'transition duration-200 hover:-translate-y-0.5 hover:shadow-cardhover' : ''
      } ${className}`}
    >
      {children}
    </div>
  )
}
